'use client';

import { usePathname, useSearchParams } from 'next/navigation';

import { SECTION_HEADER_MAX_W } from '@/app/(allowed)/search/constants';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { useSearchHistoryStore } from './_store/searchHistoryStore';
import { useSearchOverlayStore } from './_store/searchOverlayStore';
import {
  DEFAULT_SEARCH_CATEGORY,
  isSearchCategory,
  SEARCH_CATEGORY_QUERY_KEY,
} from './constants';
import { HeaderSearchOverlay } from './HeaderSearchOverlay';

export function HeaderSearchContainer() {
  const { replace, push } = useCustomRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isOpen = useSearchOverlayStore((state) => state.isOverlayOpen);
  const closeOverlay = useSearchOverlayStore((state) => state.closeOverlay);
  const data = useSearchHistoryStore((state) => state.data);
  const add = useSearchHistoryStore((state) => state.add);
  const remove = useSearchHistoryStore((state) => state.remove);
  const clear = useSearchHistoryStore((state) => state.clear);

  const currentKeyword = searchParams.get('q') ?? '';
  const categoryParam = searchParams.get(SEARCH_CATEGORY_QUERY_KEY);
  const currentCategory = isSearchCategory(categoryParam)
    ? categoryParam
    : DEFAULT_SEARCH_CATEGORY;

  const submit = (keyword: string) => {
    const trimmed = keyword.trim();

    add(trimmed);
    closeOverlay();

    const nextParams = new URLSearchParams();
    nextParams.set('q', trimmed);
    if (currentCategory !== DEFAULT_SEARCH_CATEGORY) {
      nextParams.set(SEARCH_CATEGORY_QUERY_KEY, currentCategory);
    }
    const url = `${ROUTES.SEARCH.pathname}?${nextParams.toString()}`;

    if (pathname === ROUTES.SEARCH.pathname) {
      replace(url, { scroll: false });
      window.scrollTo(0, 0);
    } else {
      push(url);
    }
  };

  return (
    <HeaderSearchOverlay
      isOpen={isOpen}
      keyword={currentKeyword}
      onClose={closeOverlay}
      onSearch={submit}
      recentKeywords={data ?? []}
      onSelectRecent={submit}
      onRemoveRecent={remove}
      onClearRecent={clear}
      searchBarMaxWClass={SECTION_HEADER_MAX_W[currentCategory]}
    />
  );
}
